import { useFormContext } from 'react-hook-form';
import { Card, Textarea } from '@shared/ui';
import { fieldToUppercase } from 'library/helpers/events';
import * as st from './styles.module.scss';

export const Description = (): JSX.Element => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <fieldset>
      <h3>Описание</h3>
      <Card className={st.description}>
        <Textarea
          autosize
          {...register('description', {
            onChange: (e) => (e.target.value = fieldToUppercase(e)),
          })}
          required={!!errors?.description}
        />
      </Card>
    </fieldset>
  );
};
